import CampaignModel from "./CampaignModel.js";
// import DatetimeHelper from '@/helper/DatetimeHelper.js';

export default function CategoryModel(dict) {
    // let cacheImg = '?t='+DatetimeHelper.getTimeCacheHour();
    this.count = dict.count;
    this.id = dict.id;
    // this.imageActive = `${dict.image_url}_active` + cacheImg;
    // this.imageInactive = `${dict.image_url}_inactive` + cacheImg;
    // this.image = dict.image_url + cacheImg;
    this.imageActive = `${dict.image_url}_active`;
    this.imageInactive = `${dict.image_url}_inactive`;
    this.image = dict.image_url;
    this.listConfig = dict.list_config;
    this.mode = dict.mode;
    this.name = dict.name;
    this.nameEn = dict.name_en;
    this.nameTh = dict.name_th;
    this.tags = dict.tags;

    this.subcats = [];
    if(dict.subcats && dict.subcats instanceof Array) {
        let arrSubCat = dict.subcats;
        if (arrSubCat.length > 0) {
            for(let i = 0; i < arrSubCat.length; i++) {
                this.subcats.push(new CategoryModel(arrSubCat[i]));
            }
        }
    }

    this.campaigns = [];
    if (dict.campaigns) {
        let arrItem = dict.campaigns
        if (arrItem.length > 0) {
            for(let j = 0; j < arrItem.length; j++) {
                this.campaigns.push(new CampaignModel(arrItem[j]));
            }
        }
    }

    if (dict.CategoryId && dict.CategoryId != 0) {
        this.id = dict.CategoryId;
    }

    if (dict.Name) {
        this.name = dict.Name;
    }

    if (dict.NameEn) {
        this.nameEn = dict.NameEn;
    }
}
